import { Link } from 'react-router-dom';

function ContactUs() {
    document.title = 'Varosa - Contact Us';
    return (
        <>
            {/* Header Start */}
            <div className="container-fluid bg-breadcrumb">
                <div className="container text-center py-5" style={{maxWidth: '900px'}}>
                    <h3 className="text-white display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">Contact Us</h3>
                    <ol className="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item active text-primary">Contact</li>
                    </ol>    
                </div>
            </div>
            {/* Header End */}

            {/* Contact Start */}
            <div className="container-fluid contact py-5">
                <div className="container py-5">
                    <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style mb-4">
                            <h4 className="sub-title text-white px-3 mb-0">Contact Us</h4>
                        </div>
                        <p className="mb-0 text-black-50"><b>VAROSA HEALTH TECHNOLOGIES PRIVATE LIMITED <br />CIN: U86900WB2025PTC278863</b></p>
                    </div>
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-5 col-xl-5 contact-form wow fadeInLeft" data-wow-delay="0.1s">
                            <h2 className="display-5 text-white mb-2">Get in Touch</h2>
                            <form>
                                <div className="row g-3">
                                    <div className="col-lg-12 col-xl-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control bg-transparent border border-white" id="name" placeholder="Your Name" />
                                            <label htmlFor="name">Your Name</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <div className="form-floating">
                                            <input type="email" className="form-control bg-transparent border border-white" id="email" placeholder="Your Email" />
                                            <label htmlFor="email">Your Email</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <div className="form-floating">
                                            <input type="phone" className="form-control bg-transparent border border-white" id="phone" placeholder="Phone" />
                                            <label htmlFor="phone">Your Phone</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control bg-transparent border border-white" id="project" placeholder="Project" />
                                            <label htmlFor="project">Your Project</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-floating">
                                            <input type="text" className="form-control bg-transparent border border-white" id="subject" placeholder="Subject" />
                                            <label htmlFor="subject">Subject</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-floating">
                                            <textarea className="form-control bg-transparent border border-white" placeholder="Leave a message here" id="message" style={{ height: '160px' }}></textarea>
                                            <label htmlFor="message">Message</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button className="btn btn-light text-primary w-100 py-3">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-lg-2 col-xl-2 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="bg-transparent rounded">
                                <div className="d-flex flex-column align-items-center text-center mb-4">
                                    <div className="bg-white d-flex align-items-center justify-content-center mb-3" style={{width: '90px', height: '90px', borderRadius: '50px'}}><i className="fa fa-map-marker-alt fa-2x text-primary"></i></div>
                                    <h4 className="text-dark">Addresses</h4>
                                    <p className="mb-0 text-white">63, A.C. ROAD, (LANE-10), P.O. KHAGRA, BERHAMPORE, KHAGRA, MURSHIDABAD, BERHAMPORE, WEST BENGAL - 742103</p>
                                </div>
                                <div className="d-flex flex-column align-items-center text-center mb-4">
                                    <div className="bg-white d-flex align-items-center justify-content-center mb-3" style={{width: '90px', height: '90px', borderRadius: '50px'}}><i className="fa fa-phone-alt fa-2x text-primary"></i></div>
                                    <h4 className="text-dark">Mobile</h4>
                                    <p className="mb-0 text-white">Support & Helpline: +91 8240112175<br />Office Number (10am-6pm): +91 3482329183</p>
                                </div> 
                                <div className="d-flex flex-column align-items-center text-center">
                                    <div className="bg-white d-flex align-items-center justify-content-center mb-3" style={{width: '90px', height: '90px', borderRadius: '50px'}}><i className="fa fa-envelope-open fa-2x text-primary"></i></div>
                                    <h4 className="text-dark">Email</h4>
                                    <p className="mb-0 text-white">varosahealth@gmail.com</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-xl-5 wow fadeInRight" data-wow-delay="0.3s">
                            <div className="d-flex justify-content-center mb-4">
                                <a className="btn btn-lg-square btn-light rounded-circle mx-2" href=""><i className="fab fa-facebook-f"></i></a>
                                <a className="btn btn-lg-square btn-light rounded-circle mx-2" href=""><i className="fab fa-twitter"></i></a>
                                <a className="btn btn-lg-square btn-light rounded-circle mx-2" href=""><i className="fab fa-instagram"></i></a>
                                <a className="btn btn-lg-square btn-light rounded-circle mx-2" href=""><i className="fab fa-linkedin-in"></i></a>
                            </div>
                            <div className="rounded h-100">
                                <iframe className="rounded w-100" 
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3641.8421192764336!2d88.24300538582413!3d24.107047019386247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f97ddf0876bb25%3A0xc10d52b2519053cb!2s316%2C%20Netaji%20Rd%2C%20Berhampore%2C%20West%20Bengal%20742103!5e0!3m2!1sen!2sin!4v1764072404714!5m2!1sen!2sin" 
                                    title="Varosa HQ Location" 
                                    style={{height: '500px'}} 
                                    allowfullscreen="" 
                                    loading="lazy" 
                                    referrerpolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Contact End */}
        </>
    );
}

export default ContactUs;
